import BtDemo2 from '../../../class/template/bt/BtDemo2'
import App from '../../../class/App.js'
import {getUrlParams} from "../../../common/util";


window.MTG_LAUNCH_btDemo2 = function (cb) {
    App.enableDebugMode()
    const query = getUrlParams()
    let fetchFunc
    console.log('window.query===》', query)
    if(query.isDeepTemplate === 'true'){
        console.log('query.isDeepTemplate===》', query)
        fetchFunc = App.getDataSourceByPostMessage
        init(fetchFunc)
    }else{
        App.onJSBridgeConnected(()=>{init()})
    }


    function init(fetchFunc){
        App.initMultipleCampaigns(BtDemo2, cb, fetchFunc).then(({data, tpl})=>{

            const { campaignList } = data
            if(App.rootView){
                console.log('rootview-:', App.rootViewId, App.rootView)
            }
            //App.readyToShowAD()


            App.readyToShowAD()
            /*tpl.whenLoad().then(()=>{
                App.readyToShowAD()
            }).catch(()=>{
                App.failureToShowAD()
            })*/

            /*tpl.onAllTplPreloadFinished(()=>{
                //App.readyToShowAD()
            })*/

            App.onAdShow((res) => {
                console.warn('onAdShow((res) => {', {res})
            })
        }).catch(err=>{
            console.error('promise catch an error when init:',err)
        })
    }
}
